"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkText = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var Text_1 = require("./Text");
var react_1 = __importDefault(require("react"));
var styled_system_1 = require("styled-system");
var theme_1 = require("./theme");
var getTextStyle = function (size) {
    switch (size) {
        case "small":
            return "uiSmall500";
        case "medium":
            return "uiLarge500";
        case "large":
            return "uiSmall600";
    }
};
/**
 * A component for styled anchor tags
 * https://www.figma.com/file/5otfo5aNKz5sgwGJZxCXrP/WIP-Pallet-DS2022?node-id=21%3A1287
 * @param {string} href - Anchor tag href link
 * @param {string=} [size=medium] - Can be small or medium
 * @param {boolean=} [disabled=false] - Prevents the link from being interacted with
 * @param {ReactComponent=} icon - React component for displaying an icon next to the link
 */
var LinkText = function (_a) {
    var icon = _a.icon, _b = _a.size, size = _b === void 0 ? "medium" : _b, children = _a.children, props = __rest(_a, ["icon", "size", "children"]);
    var href = props.href, disabled = props.disabled, onClick = props.onClick;
    var textStyle = getTextStyle(size);
    var showHref = href && !disabled;
    var showOnClick = onClick && !disabled;
    return (react_1.default.createElement(StyledLink, __assign({ as: showHref ? "a" : "div", size: size }, props, { href: showHref ? href : undefined, onClick: showOnClick ? onClick : undefined }),
        icon,
        react_1.default.createElement(Text_1.Text, { variant: textStyle }, children)));
};
exports.LinkText = LinkText;
var StyledLink = styled_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 6px;\n  cursor: pointer;\n  text-decoration: none;\n  color: ", ";\n  stroke: ", ";\n  display: inline-flex;\n  align-items: center;\n  grid-gap: 8px;\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:active,\n  &:focus {\n    background: ", ";\n  }\n\n  ", ";\n\n  ", "\n\n  ", "\n"], ["\n  border-radius: 6px;\n  cursor: pointer;\n  text-decoration: none;\n  color: ", ";\n  stroke: ", ";\n  display: inline-flex;\n  align-items: center;\n  grid-gap: 8px;\n\n  &:hover {\n    background: ", ";\n  }\n\n  &:active,\n  &:focus {\n    background: ", ";\n  }\n\n  ", ";\n\n  ", "\n\n  ", "\n"])), function (props) { return (props.color ? props.color : theme_1.theme.colors.blue700); }, function (props) { return (props.color ? props.color : theme_1.theme.colors.blue700); }, theme_1.theme.colors.gray200, theme_1.theme.colors.gray300, function (_a) {
    var disabled = _a.disabled;
    return disabled &&
        "\n        && {\n            background: ".concat(theme_1.theme.colors.white, ";\n            color: ").concat(theme_1.theme.colors.gray400, ";\n            cursor: default;\n            stroke: ").concat(theme_1.theme.colors.gray400, ";\n        }\n    ");
}, (0, styled_system_1.variant)({
    prop: "size",
    variants: {
        small: {
            padding: "8px",
        },
        medium: {
            padding: "6px 8px",
        },
        large: {
            padding: "12px 14px",
        },
    },
}), styled_system_1.space);
var templateObject_1;
